import $ from 'jquery';
import { ajaxCall } from "./ajax-call";

const relatedBooksSelector = '.js-related-books';

function loadScript(url, callback) {
    var script = document.createElement("script");
    script.src = url;
    script.type = "text/javascript";
    script.onload = callback;      // runs after the script is loaded and executed
    document.head.appendChild(script);
}

const setupRelatedBooks = () => {
    const relatedBooks = document.querySelector(relatedBooksSelector);
    const {embla_js_path} = universityPressThemeSettings
    if( !relatedBooks ) return;

    const parameters = relatedBooks.dataset.parameters;

    let hasLoaded = false;
    const scrollTrigger = relatedBooks.offsetTop - window.innerHeight;

    const onScroll = async () => {
        if( hasLoaded ) return;

        if( window.scrollY > scrollTrigger ) {
            hasLoaded = true;
            relatedBooks.style.visibility = 'visible';

            try {
                await ajaxCall('', relatedBooks, 'upt_related_books', parameters);
                const newCarousel = $(relatedBooks.querySelector('.related-books__container'));
                if( !newCarousel ) return;
                loadScript(embla_js_path, () => {
                    window.supapress.initEmbla(newCarousel.find('.isbn-carousel'));
                });
            } catch( error ) {
                console.error('Failed to load related books via AJAX:', error);
                relatedBooks.style.display = 'none';
            }
        }
    };

    window.addEventListener('scroll', onScroll, {passive: true});
};

document.addEventListener("DOMContentLoaded", () => {
    setupRelatedBooks();
});
